import { useQuery, useMutation } from 'react-query'
import { useGqlClient, getSurveyAnswerCount, getCrmSurveys } from '@aposphaere/core-kit'
import { QueryOptions } from './utils'
import { useCrmContext } from '../../contexts/crmContext'
import { gql } from 'graphql-request'

type SurveyAnswerCountQueryProps = {
  clusterId?: string
  date?: { from: string; to: string }
  options?: QueryOptions<number>
  enabled?: boolean
}

type CrmSurvey = {
  id: string
  question: string
  crm_survey_answer_options: {
    id: string
    label: string
  }[]
}

export const useSurveyAnswerCountQuery = (props?: SurveyAnswerCountQueryProps) => {
  const gqlClient = useGqlClient()
  const { activeCluster } = useCrmContext()
  const clusterId = props?.clusterId || activeCluster.id
  const variables = { pharmacyClusterId: clusterId, date: props?.date }
  return useQuery(
    ['survey_answer_count', `cluster-${props?.clusterId}`, `dateRange-${JSON.stringify(props?.date)}`],
    async () => {
      const data = await gqlClient.request<{ getSurveyAnswerCount: { total_count: number } }>(getSurveyAnswerCount, variables)
      return data?.getSurveyAnswerCount?.total_count ?? 0
    },
    { staleTime: Infinity, enabled: props?.enabled ?? true, ...props?.options },
  )
}


export const useGetCrmSurveysQuery = (props: { pharmacyId: string; enabled?: boolean; options?: QueryOptions<CrmSurvey[]> }) => {
  const gqlClient = useGqlClient()

  return useQuery(
    ['crm_surveys', props.pharmacyId],
    async () => {
      const data = await gqlClient.request<{
        crm_surveys: CrmSurvey[]
      }>(getCrmSurveys, { pharmacy_id: props.pharmacyId })
      return data?.crm_surveys ?? []
    },
    { staleTime: Infinity, enabled: props.enabled ?? true, ...props.options },
  )
}


export const createCrmSurveyAnswers = gql`
  mutation CreateCrmSurveyAnswers($pharmacy_id: ID!, $crm_surveys: [CrmSurveyInput]!) {
    createCrmSurveyAnswers(pharmacy_id: $pharmacy_id, crm_surveys: $crm_surveys)
  }
`

export const useCreateCrmSurveyAnswersMutation = () => {
  const gqlClient = useGqlClient()
  return useMutation(
    (variables: { pharmacy_id: number; crm_surveys: { crm_survey_id: number; crm_survey_answer_option_id: number }[] }) =>
      gqlClient.request(createCrmSurveyAnswers, variables)
  )
}